import styled from '@emotion/styled/macro';

export const Image = styled.img`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: ${props => props.theme.fontSize.huge};
    color: ${props => props.theme.componentColours.betPromo.text};
    height: 100%;

    @media (min-width: 549px) {
        width: 100%;
    }
`;

export const MobileImage = styled(Image)`
    display: none;
    max-width: 100%;
    height: auto;

    @media (max-width: 768px) {
        display: block;
    }
`;

export const DesktopImage = styled(Image)`
    display: block;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const PromoLink = styled.a`
    text-decoration: none;
    color: white;
    cursor: pointer;
`;
